import { useEffect } from "react"
import { node } from "prop-types"
import { useLocation, useNavigate } from "@tanstack/react-router"
import { useAuthState } from "react-firebase-hooks/auth"
import Box from "@mui/material/Box"
import CircularProgress from "@mui/material/CircularProgress"
import { auth } from "@/lib/firebase"
import { isPublicPath } from "@/helpers/isPublicPath"

function AuthGate({ children }) {
  const navigate = useNavigate()
  const pathname = useLocation({ select: (l) => l.pathname })
  const [user, loading] = useAuthState(auth)

  useEffect(() => {
    if (loading) return
    if (!user && !isPublicPath(pathname)) {
      navigate({ to: "/auth", replace: true })
    }
  }, [user, loading, pathname, navigate])

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh"
        }}
      >
        <CircularProgress aria-label="Loading" />
      </Box>
    )
  }
  return children
}

AuthGate.propTypes = {
  children: node.isRequired
}

export default AuthGate
